import PurchasingHistorySearchResult from './PurchasingHistorySearchResult';

export default PurchasingHistorySearchResult;
